chopstickChart();
chopstickTooltip();
chopstickPopover();
chopstickTabs();
chopstickToggle();
chopstickNavigation();
chopstickBlazy();
chopstickFileInput();
chopstickBarcode();
chopStickGtmEvents();

jsSelectize.init();
jsBilling.init();
jsPopup.init();
